const LOG_AMPLITUDE_EVENT = 'LOG_AMPLITUDE_EVENT';
const SET_AMPLITUDE_USER_ID = 'SET_AMPLITUDE_USER_ID';

const logAmplitudeEvent = (eventName, eventProperties) => ({
  type: LOG_AMPLITUDE_EVENT,
  eventName,
  eventProperties,
});

const setAmplitudeUserId = userId => ({
  type: SET_AMPLITUDE_USER_ID,
  userId,
});

export {
  LOG_AMPLITUDE_EVENT,
  logAmplitudeEvent,
  SET_AMPLITUDE_USER_ID,
  setAmplitudeUserId,
};



// WEBPACK FOOTER //
// ./src/redux/actions/amplitude.js